export function OrDivider() {
    return (
        <div className="flex items-center gap-6">
            <div className="flex-1 h-0 outline outline-1 outline-neutral-300" />
            <span className="text-lg text-brand-forest">OR</span>
            <div className="flex-1 h-0 outline outline-1 outline-neutral-300" />
        </div>
    )
}
